import { render } from "./ClientAdd.vue?vue&type=template&id=136f6c2a&scoped=true"
import script from "./ClientAdd.vue?vue&type=script&lang=js"
export * from "./ClientAdd.vue?vue&type=script&lang=js"

import "./ClientAdd.vue?vue&type=style&index=0&id=136f6c2a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136f6c2a"]])

export default __exports__